import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { convertObjectToArray, displayPromoFooter, getRemotedbUrl, isNotEmpty } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import Tooltip from '../builder/Tooltip.js';

import PolicyButton from './buttons/PolicyButton';
import TermsButton from './buttons/TermsButton';
import CookiesButton from './buttons/CookiesButton';
import { useCSS } from '../../lib/hooks.js';

const FooterFlex = (props) => {
	useCSS('comp/promo_footer.css');

	const promotion = props?.promo ?? false;
	const layout_props = promotion?.layout_props ?? {};
	const current_lang = props?.current_lang ?? (promotion?.default_locale ?? 'eng');
	const is_managing_section = props?.is_managing_section ?? false;
	const is_builder = props?.is_builder ?? false;
	const is_wl = (promotion.promo_type == '2') ? true : false;

	const localized_locales = convertObjectToArray(props?.localized_locales ?? {});
	const locs = Object.keys(props?.locs ?? {});

	useEffect(() => {
		setTimeout(() => {
			if(window.adaptWidgetHeight != undefined) adaptWidgetHeight();
		}, 500);
	}, []);

	if(promotion === false) return null;

	const changePromotionLang = (new_lang) => {
		if(is_builder) return;

		$.post(getRemotedbUrl(`/promotions/setlang/${promotion.id}`), { lang:new_lang }, () => {
			const _gets = getUrlVars();

			if(Object.keys(_gets).length > 0) {
				_gets.lc = `lc=${new_lang}`;
				let new_url = props?.actual_url ?? window.location.pathname;
				let is_first_get = true;

				Object.keys(_gets).map((_get) => {
					if(_gets.hasOwnProperty(_get)) {
						new_url += `${(is_first_get) ? '?' : '&'}${_gets[_get]}`;
						is_first_get = false;
					}
				});

				window.location.href = new_url;
			} else {
				window.location.reload();
			}
		});
	};

	const navigateToFooterEditor = () => {
		window.location.hash = 'footer';
	};

	const { hide_footer, display_powered, display_toc, display_policy, display_cookies, display_langs } = displayPromoFooter(promotion, locs.length);
	if(hide_footer && !is_managing_section) return null;

	let main_classes = ['gui_footer'];
	main_classes.push((is_wl) ? 'footer_credit' : 'footer_easypromos');
	const extra_footer_classes = props?.extra_footer_classes ?? false;
	if(extra_footer_classes !== false) main_classes.push(extra_footer_classes);

	if(hide_footer) {
		main_classes.push('not_awesome footer_not_enabled');

		return (
			<footer class={main_classes.join(" ")}>
				<ActionLink
					icon='knk-alert redIcon'
					_class={{ other:'gui_small_icon original_color_item' }}
				>The footer is not visible because there is no content to display</ActionLink>
			</footer>
		)
	}

	const custom_footer = (!is_wl) ? (props?.custom_footer ?? false) : false;
	const ep_web_url = (!is_wl && promotion.promotion_type_id != undefined) ? true : false;

	const styles = props?.styles ?? null;

	let display_any_legal = (display_toc || display_policy || display_cookies) ? true : false;
	if(props?.hide_legals ?? false) display_any_legal = false;

	const utms = [
		`utm_source=EPromotions`,
		`utm_medium=footer`,
		`utm_campaign=${promotion.id}`,
		`utm_content=${(promotion.promo_type == '1') ? 'premium' : 'basic'}`,
	];
	const ep_link_utms = `${window.web_base_url}?${utms.join("&")}`;

	return (
		<footer class={main_classes.join(" ")} style={styles}>
			{(layout_props?.footer?.sponsors_image ?? false) && (
				<div class="sponsors">
					{(isNotEmpty(layout_props.footer, 'sponsors_url')) ? (
						<ActionLink
							autotranslate={false}
							_href={layout_props.footer.sponsors_url}
							_target='_blank'
							_class={{ other:'sponsors_link' }}
						>
							<img src={layout_props.footer.full_sponsors_image} width="100%" alt="" />
						</ActionLink>
					) : (
						<img src={layout_props.footer.full_sponsors_image} width="100%" alt="" />
					)}
				</div>
			)}

			{(display_powered) && (
				<div
					class="powered_by"
					dangerouslySetInnerHTML={{ __html:promotion.powered.replace(/\n/g, '<br />') }}
				/>
			)}

			{(display_any_legal) && (
				<ul class="legal_texts">
					{(display_toc) && (
						<li>
							<TermsButton
								promotion={promotion}
								icon={false}
							/>
						</li>
					)}

					{(display_policy) && (
						<li>
							<PolicyButton
								promotion={promotion}
								icon={false}
							/>
						</li>
					)}

					{(display_cookies) && (
						<li>
							<CookiesButton
								promotion={promotion}
								icon={false}
							/>
						</li>
					)}
				</ul>
			)}

			{(display_langs) && (
				<ul class="avail_langs_flex">
					{!is_builder && localized_locales.sort((a, b) => {
						return (a.v < b.v ? -1 : 1);
					}).map((loc) => {
						const lang_label = loc.v;
						if(lang_label == undefined) return null;

						const _class = (loc.k == current_lang) ? 'selected' : null;

						return (
							<li key={`lang_${loc.k}`} id={`l_${loc.k}`} class={_class}>
								<ActionLink
									onClick={() => changePromotionLang(loc.k)}
									_class={{other:`is_${loc.direction}`}}
									autotranslate={false}
								>{lang_label}</ActionLink>
							</li>
						)
					})}

					{locs.sort().map((loc, l) => {
						const localized_locale = localized_locales.find((obj) => { return obj.key == loc });
						const lang_label = localized_locale?.label ?? localized_locale.lang;

						if(lang_label == undefined || localized_locale == undefined) return null;
						
						const _class = (loc == current_lang) ? 'selected' : null;

						return (
							<li key={`lang_${l}`} class={_class}>
								<ActionLink
									onClick={() => changePromotionLang(loc)}
									_class={{other:((localized_locale.direction != undefined) ? `is_${localized_locale.direction}` : 'is_ltr')}}
									autotranslate={false}
								>{lang_label}</ActionLink>
							</li>
						)
					})}
				</ul>
			)}

			{(ep_web_url || custom_footer) && (
				<ul class="footer_ep easypromos_credit_flex">
					<li>
						<ActionLink
							_href={ep_link_utms}
							_target="_blank"
							icon='ep-easypromos-logo'
							_class={{ other:'only_desktop' }}
						>{(custom_footer !== false) ? custom_footer : "Made with Easypromos"}</ActionLink>

						<ActionLink
							_href={ep_link_utms}
							_target="_blank"
							icon='ep-easypromos-logo'
							_class={{ other:'only_mobile' }}
						>Easypromos</ActionLink>
					</li>
				</ul>
			)}

			{(is_builder && !is_managing_section) && (
				<ActionLink
					_class={{other:'is_fullscreen relative_to_container'}}
					onClick={() => navigateToFooterEditor()}
					tooltip={<Tooltip position="top" with_icon={false}>Edit footer</Tooltip>}
					autotranslate={false}
				>
					<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" height="100%" alt="" />
				</ActionLink>
			)}
		</footer>
	)
}

export default injectIntl(FooterFlex);